export default [
    {
        name: 'apply-now.index',
        path: '/apply-now',
        component: () => import('@/views/apply-now/index.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    }
];
